export const theme = {
  colors: {
    primary: {
      bariBlue: '#0090FF',
      black: '#101010',
      lightGray: '#F5F6F7',
      transparentBg: '#F6F6F6',
      transparentBgOpacity: 'rgb(246 246 246 / 60%)',
      transparentBorder: '#E5E5E5',
      white: '#FFFFFF'
    },
    secondary: {
      black: '#171A1C',
      black100: '#282828',

      blue100: '#0073C8',
      blue200: '#0090FF',
      blue300: '#12A6FB',
      blue400: '#4AAEF2',
      blue500: '#A0D8FD',
      blue550: '#D8EFFD',
      blue600: '#E6F5FE',

      gray100: '#424548',
      gray200: '#626568',
      gray300: '#8A8D8F',
      gray350: '#8E8E8E',
      gray375: '#B7B7B7',
      gray400: '#B5B8BA',
      gray450: '#CFD2D3',
      gray500: '#DFE1E2',
      gray600: '#F5F6F7',

      green100: '#569522',
      green200: '#6CB92F',
      green300: '#8DD942',
      green350: '#83C486',
      green400: '#A3E45A',
      green500: '#D6F6A7',
      green550: '#E2FDE9',
      green600: '#F3FCE4',

      lilac100: '#8A2A99',
      lilac200: '#B339C5',
      lilac300: '#D259E4',
      lilac400: '#E074EF',
      lilac500: '#F1BDF8',
      lilac600: '#F9F0FC',

      moss100: '#2B5447',
      moss200: '#387A66',
      moss300: '#489D83',
      moss400: '#5DBD9F',
      moss500: '#A1DDCA',
      moss600: '#DAF1EA',

      navy100: '#2F3E6A',
      navy200: '#3E538E',
      navy300: '#4764B8',
      navy400: '#607DD0',
      navy500: '#9DAFE0',
      navy600: '#D9DFF2',

      orange100: '#D66700',
      orange200: '#FF7C03',
      orange300: '#FF923D',
      orange400: '#FFA958',
      orange500: '#FFD8AC',
      orange600: '#FFF4E7',

      purple100: '#6139C0',
      purple200: '#7343E3',
      purple300: '#865AF2',
      purple400: '#9972F6',
      purple500: '#D1BEFC',
      purple550: '#E8E2FD',
      purple600: '#F3F0FE',

      red100: '#D02931',
      red200: '#F83D44',
      red300: '#FF6A6F',
      red400: '#FF8789',
      red500: '#FFC9CA',
      red600: '#FFF5F5',

      rose100: '#AC1C4E',
      rose200: '#DD316D',
      rose300: '#F76495',
      rose400: '#FD82AC',
      rose500: '#FFC2D7',
      rose550: '#FFE6E6',
      rose600: '#FFF0F6',

      yellow100: '#E0A229',
      yellow200: '#FFB82E',
      yellow300: '#FFC53A',
      yellow400: '#FFD550',
      yellow500: '#FFED9F',
      yellow600: '#FFF9DD'
    },
    states: {
      disabled: '#c2c2c2',
      hoverBlue: '#008af5',
      selectedLightBlue: '#F7FCFF'
    }
  },
  weights: {
    thin: 100,
    light: 300,
    regular: 400,
    semibold: 600,
    bold: 700
  },

  heights: {
    superTight: 1,
    tight: 1.25,
    medium: 1.5,
    distant: 1.75,
    superDistant: 2
  },

  sizes: {
    nano: '10px',
    '3xs': '12px',
    '2xs': '14px',
    xs: '16px',
    sm: '20px',
    md: '24px',
    lg: '32px',
    xl: '40px',
    '2xl': '48px',
    '3xl': '64px',
    '4xl': '80px',
    display1: '96px',
    display2: '112px'
  }
};
